import React, { useState, useEffect, useMemo } from 'react';
import { SearchBox, TabPanel, Tabs } from 'tea-component';
import { connect, useDispatch, useIntl } from 'umi';

import SvgIcon from '@/pages/home/components/SvgIcon';

import RelatedGame from './components/RelatedGame';
import '@/pages/dashboard/assets/scss/components/navigation/navigationHeader.scss';
import './index.scss';
import { getGameList } from '../../services';

let cancel: (() => void) | null = null;
let timeout: NodeJS.Timeout;

function GameSelector(props: any) {
  const { formatMessage } = useIntl();
  const {
    userInfo,
    userInfoLoading,
    gameList: apiGameList,

    latelyGameList,
    apiCollectList: serverCollectList,

    gameListLoading = true,
    latelyGameListLoading = true,
    apiCollectListLoading = true,
  } = props;

  const [searchGameList, setSearchGameList] = useState<any[]>([]);
  const [searchGameListLoading, setSearchGameListLoading] = useState(true);

  const tabs = [
    // 先做搜索优化，关联需要后端支持
    {
      id: 'my_related',
      icon: 'uesr-heart',
      label: formatMessage({ id: 'My Related' }),
      component: (props: any = {}) => (
        <RelatedGame
          recentList={recentList}
          gameList={collectList}
          rencentListLoading={latelyGameListLoading}
          gameListLoading={apiCollectListLoading}
          hasRecentList={true}
          hasGameTypeChange={false}
          isCollect={true}
          isFollowing={true}
          gameListTitle={formatMessage({ id: 'My Following' })}
          handleCollect={handleCollect}
          handleCollectListUpdate={handleCollectListUpdate}
          handleEmptyCollectDescTextClick={() => {
            setActiveId('all_game');
          }}
          allGameList={gameList}
        />
      ),
    },
    {
      id: 'all_game',
      icon: 'outline-gamepad',
      label: formatMessage({ id: 'All Games' }),
      component: (props: any = {}) => (
        <RelatedGame
          gameListStyle={{ marginTop: 0 }}
          gameList={gameList}
          rencentListLoading={latelyGameListLoading}
          gameListLoading={gameListLoading}
          hasGameListTitle={false}
          isCollect={true}
          handleCollect={handleCollect}
        />
      ),
    },
    {
      id: 'tencent_game',
      icon: 'tc-game',
      label: formatMessage({ id: 'Tencent Games' }),
      component: (props: any = {}) => (
        <RelatedGame
          gameListStyle={{ marginTop: 0 }}
          gameList={tencentGameList}
          rencentListLoading={latelyGameListLoading}
          gameListLoading={gameListLoading}
          hasGameListTitle={false}
          isCollect={true}
          handleCollect={handleCollect}
        />
      ),
    },
    {
      id: 'competitor',
      icon: 'vs-icon',
      label: formatMessage({ id: 'Competitor' }),
      component: (props: any = {}) => (
        <RelatedGame
          gameListStyle={{ marginTop: 0 }}
          gameList={competitorGameList}
          rencentListLoading={latelyGameListLoading}
          gameListLoading={gameListLoading}
          hasGameListTitle={false}
          isCollect={true}
          handleCollect={handleCollect}
        />
      ),
    },
  ];
  const [activeId, setActiveId] = useState<string>(tabs[0].id);

  const getSearchGameList = async (params: any) => {
    setSearchGameListLoading(true);
    try {
      const curSearchGameList = await getGameList(
        params,
        (cancelToken: any) => (cancel = cancelToken),
      );
      setSearchGameList(curSearchGameList);
    } catch {
      setSearchGameList([]);
    }

    setSearchGameListLoading(false);
  };

  useEffect(() => {
    if (!userInfo) return;
    if (apiGameList?.length > 0) return; // 如果已经有 gameList 数据就不重复获取了
    dispatch({
      type: 'opinionGame/getChangeGameList',
      payload: {
        need_country_publisher: false,
        need_mobile_editions: true,
      },
    });
  }, [userInfo]);

  const [apiCollectList, setApiCollectList] = useState(serverCollectList || []);

  useEffect(() => {
    setApiCollectList(serverCollectList || []);
  }, [serverCollectList]);

  const [tencentGameList, setTencentGameList] = useState([]);
  const [competitorGameList, setCompetitorGameList] = useState([]);
  const [recentList, setRecentList] = useState<any>([]);
  const [resultList, setResultList] = useState<any>([]);

  /**
   * 所有游戏列表的list 和 游戏Map
   */
  const [gameList, gameListMap] = useMemo(() => {
    const localGameList = apiGameList?.map((item: any) => ({
      ...item,
      collect: apiCollectList?.includes(item.edition_unified_id),
    }));

    const localGameListMap = localGameList?.reduce((result: any, cur: any) => {
      const newResult = Object.assign(result);
      newResult[cur.edition_unified_id] = cur;
      return newResult;
    }, {});

    return [localGameList, localGameListMap];
  }, [apiGameList, apiCollectList]);

  // 收藏游戏的列表和游戏map
  const [collectList, collectListMap] = useMemo(() => {
    let curList = apiCollectList;
    if (!curList) curList = [];

    const curApiCollectList = curList
      ?.map((curCollectListItem: string) => gameListMap?.[curCollectListItem])
      ?.filter((item: any) => !!item);

    const localCurCollectList = curApiCollectList?.map?.((item: any) => ({
      ...item,
      collect: true,
    }));

    const localCollectListMap = localCurCollectList.reduce(
      (result: any, cur: any) => {
        const newResult = Object.assign(result);
        newResult[cur.edition_unified_id] = cur;
        return newResult;
      },
      {},
    );

    return [localCurCollectList, localCollectListMap];
  }, [apiCollectList, gameListMap]);

  useEffect(() => {
    setTencentGameList(
      gameList?.filter((item: any) => item.source_type === 'tencentgames'),
    );
    setCompetitorGameList(
      gameList?.filter((item: any) => item.source_type === 'competitors'),
    );
  }, [gameList]);

  useEffect(() => {
    let curList = latelyGameList;
    if (!curList) {
      curList = [];
    }
    setRecentList(
      curList?.map?.((item: any) => ({
        ...item,
        collect: !!collectListMap[item.edition_unified_id],
      })),
    );
  }, [latelyGameList, collectListMap]);

  useEffect(() => {
    let curList = searchGameList;
    if (!curList) {
      curList = [];
    }
    setResultList(
      curList?.map?.((item: any) => ({
        ...item,
        collect: !!collectListMap[item.edition_unified_id],
      })),
    );
  }, [searchGameList, collectListMap]);

  const dispatch = useDispatch();

  // 需和左侧边栏展开收起联动，收起尺寸为56
  const leftMenuWidth = 250;

  const handleActiveChange = (id: any) => {
    // 查询模式下禁止切换
    if (isSearchMode) return;
    // isFirst.current = false;
    setActiveId(id);
  };

  const [isSearchMode, setIsSearchMode] = useState(false);
  const [search, setSearch] = useState('');

  const handleSearchChange = (searchValue: string) => {
    clearTimeout(timeout);

    cancel?.();
    cancel = null;

    if (!searchValue) {
      setSearch(searchValue);
      setIsSearchMode(false);
      return;
    }

    timeout = setTimeout(() => {
      setIsSearchMode(true);
      setSearch(searchValue);
      getSearchGameList({
        entity_name: searchValue,
        need_country_publisher: false,
        need_mobile_editions: true,
      });
    }, 400);
  };

  const handleSearch = (searchValue: string) => {
    if (!searchValue) return;

    setIsSearchMode(true);
    getSearchGameList({
      entity_name: searchValue,
    });
  };

  const searchList = useMemo(() => {
    if (searchGameListLoading) return [];
    return resultList;
  }, [resultList, searchGameListLoading]);

  const handleCollectListUpdate = (collectList: any[]) => {
    dispatch({
      type: 'opinionGame/getCollectList',
      payload: {},
    });
  };

  const handleCollect = (collect: boolean, curGameInfo: any) => {
    console.log('handleCollect', collect, curGameInfo);
    let curCollectList = [];
    if (collect) {
      // 当前只有 最近列表可以点 收藏，所以这里只要处理 collect list 的变化
      curCollectList = [...apiCollectList, curGameInfo.edition_unified_id];
    } else {
      // 取消收藏，可能在最近列表点击，也可能在收藏列表点击，需要同时处理 最近列表的变化
      curCollectList = apiCollectList.filter(
        (edition_unified_id: any) =>
          edition_unified_id !== curGameInfo.edition_unified_id,
      );
    }
    setApiCollectList(curCollectList);
  };

  useEffect(() => {
    if (!userInfo) return;

    if (activeId !== 'my_related' || isSearchMode) {
      return;
    }

    dispatch({
      type: 'opinionGame/getLatelyGameList',
      payload: {},
    });
    dispatch({
      type: 'opinionGame/getCollectList',
      payload: {},
    });
  }, [userInfo, activeId, isSearchMode]);

  return (
    <div
      className="dbo-gameselector-wrap"
      style={{ left: `${leftMenuWidth + 6}px` }}
    >
      <div className="tea-drawer__body">
        <div className="tea-drawer__body-inner">
          <div className="dbo-drawer-header">
            <SearchBox
              className="drawer-search"
              autoComplete="off"
              aria-autocomplete="none"
              placeholder={formatMessage({
                id: 'Search any game in the following table',
              })}
              onChange={(value) => handleSearchChange(value?.trim() || '')}
              onClear={() => handleSearchChange('')}
              onSearch={(value) => handleSearch(value?.trim() || '')}
            />
            {!isSearchMode ? (
              <Tabs
                tabs={tabs}
                activeId={isSearchMode ? '' : activeId}
                tabBarRender={(children, tab: any) => (
                  <div
                    className="drawer-flex"
                    onClick={() => handleActiveChange(tab.id)}
                  >
                    <SvgIcon className="drawer-flex-icon" type={tab.icon} />
                    {children}
                  </div>
                )}
              />
            ) : null}
          </div>
          {isSearchMode ? (
            <div className="drawer-gamelistbox">
              <RelatedGame
                gameList={searchList}
                gameListStyle={{ marginTop: 0 }}
                gameListLoading={searchGameListLoading}
                hasGameListTitle={false}
                // recommendedList={recommendedList}
                isCollect={true}
                handleCollect={handleCollect}
                search={search}
              />
            </div>
          ) : (
            (() => {
              const activeTab = tabs.find((tab) => tab.id === activeId);
              if (!activeTab) return null;
              return (
                <TabPanel id={activeTab.id} key={activeTab.id}>
                  {activeTab.component({
                    gameList,
                    setActiveId,
                  })}
                </TabPanel>
              );
            })()
          )}
        </div>
      </div>
    </div>
  );
}

export default connect((state: any) => {
  const { loading, home, opinionGame } = state;

  return {
    userInfoLoading: loading.effects['home/getUserInfo'],
    userInfo: home.userInfo,

    gameList: opinionGame.changeGameList,
    gameListLoading: loading.effects['opinionGame/getChangeGameList'],

    latelyGameList: opinionGame.latelyGameList,
    latelyGameListLoading: loading.effects['opinionGame/getLatelyGameList'],

    searchGameList: opinionGame.searchGameList,
    searchGameListLoading: loading.effects['opinionGame/getSearchGameList'],

    apiCollectList: opinionGame.collectList,
    apiCollectListLoading: loading.effects['opinionGame/getCollectList'],
  };
})(GameSelector);
